import * as React from 'react';

import { Color } from '../../enums';
import { AccountSubmenuPosition } from '../../interfaces';

import {
  Container,
  Dot,
  IconAndLabelContainer,
  StyledMenuPosition,
  StyledMenuPositionLabel,
  StyledMenuPositionWrapper,
  Image,
  StyledIcon,
  IconContainer,
} from './accountSubmenu.styled';
import { AccountSubmenuProps } from './accountSubmenu.types';

export const AccountSubmenu: React.FC<AccountSubmenuProps> = (props: AccountSubmenuProps): JSX.Element => {
  const { className, menuPositions, activePosition }: AccountSubmenuProps = props;

  return (
    <Container className={className}>
      {menuPositions.map((position: AccountSubmenuPosition, index: number): JSX.Element => (
        <StyledMenuPositionWrapper key={`${position.label ?? ''}-${position.name ?? ''}-${index}`}>
          <StyledMenuPosition {...position} $isActive={!!position.name && activePosition === position.name} key={position.label}>
            <IconAndLabelContainer>
              <IconContainer>
                {position.icon && (
                  <StyledIcon
                    name={position.icon}
                    size={24}
                    color={(!!position.name && activePosition === position.name) ? Color.Error500 : Color.Black}
                  />
                )}
                {(position.image && !position.icon) && (
                  <Image src={position.image} alt='' />
                )}
              </IconContainer>
              <StyledMenuPositionLabel>{position.label}</StyledMenuPositionLabel>
            </IconAndLabelContainer>
            {position.isHighlighted && <Dot $color={position.highlightedColor ?? Color.Error500} />}
          </StyledMenuPosition>
        </StyledMenuPositionWrapper>
      ))}
    </Container>
  );
};
